import { Component } from '@theme/component';

class VPCatalog extends Component {
  filter(event) {
    const shape = event.target.dataset.shape;
    let count = 0;
    for (const card of this.refs.cards ?? []) {
      card.hidden = shape !== 'all' && card.dataset.shape !== shape;
      if (!card.hidden) count++;
    }
    for (const button of this.querySelectorAll('[data-shape][aria-pressed]')) {
      button.setAttribute('aria-pressed', String(button.dataset.shape === shape));
    }
    if (this.refs.status) this.refs.status.textContent = this.refs.status.dataset.label.replace('[count]', String(count));
  }
}
if (!customElements.get('vp-catalog-component')) customElements.define('vp-catalog-component', VPCatalog);
